import { __values } from "tslib";
import { Badge, Menu, MenuDivider, MenuItem, MenuList, MenuPopover, MenuSplitGroup, MenuTrigger, Tooltip, } from '@fluentui/react-components';
import { ContentActionItemType, } from '@office-start/document-types';
import React from 'react';
import { ActionMenuIcon } from './ActionMenuIcon';
import { useActionMenuItemStyles } from './ActionMenuItem.styles';
export var getMenuItems = function (menuItems) {
    var e_1, _a;
    var items = [];
    try {
        for (var menuItems_1 = __values(menuItems), menuItems_1_1 = menuItems_1.next(); !menuItems_1_1.done; menuItems_1_1 = menuItems_1.next()) {
            var menuItem = menuItems_1_1.value;
            items.push(React.createElement(ActionMenuItem, { key: "actionMenuItem_".concat(menuItem.id), menuItem: menuItem }));
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (menuItems_1_1 && !menuItems_1_1.done && (_a = menuItems_1.return)) _a.call(menuItems_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return items;
};
/**
 * When a menu item has sub menus, clicking on the menu item does not
 * stop the propagation or prevent default on its own
 * @param e Synthetic event to update
 */
var stopDefaultPropagation = function (e) {
    e.preventDefault();
    e.stopPropagation();
};
export var createFluentMenuItem = function (menuItem, styles) {
    var _a, _b, _c;
    if (menuItem.renderMenu) {
        return menuItem.renderMenu();
    }
    var hasSubMenu = menuItem.subMenus && menuItem.subMenus.length > 0;
    var titleElement = ((_a = menuItem.contentActionOptions) === null || _a === void 0 ? void 0 : _a.badgeText) ? (React.createElement("div", { className: styles.badgeContainer },
        React.createElement("span", null, menuItem.title),
        React.createElement(Badge, { color: "brand", className: styles.badge }, menuItem.contentActionOptions.badgeText))) : (menuItem.title);
    var fluentMenuItem = (React.createElement(MenuItem, { role: "menuitem", "aria-label": menuItem.ariaLabel, className: styles.menuItem, icon: React.createElement(ActionMenuIcon, { className: styles.icon, icon: (_b = menuItem.contentActionOptions) === null || _b === void 0 ? void 0 : _b.icon, isDisabled: menuItem.disabled }), key: menuItem.id, onClick: function (e) {
            stopDefaultPropagation(e);
            if (menuItem.executeAction && !menuItem.disabled) {
                menuItem.executeAction(e);
            }
        }, hasSubmenu: hasSubMenu && !((_c = menuItem.contentActionOptions) === null || _c === void 0 ? void 0 : _c.split), disabled: menuItem.disabled }, titleElement));
    if (menuItem.tooltipString) {
        return (React.createElement(Tooltip, { content: menuItem.tooltipString, relationship: "description" }, fluentMenuItem));
    }
    return fluentMenuItem;
};
export var ActionMenuItem = function (_a) {
    var _b, _c;
    var menuItem = _a.menuItem;
    var styles = useActionMenuItemStyles();
    // Divider...
    if (((_b = menuItem.contentActionOptions) === null || _b === void 0 ? void 0 : _b.itemType) ===
        ContentActionItemType.Divider) {
        return React.createElement(MenuDivider, { className: styles.menuDivider, key: menuItem.id });
    }
    // Get the current menu item...
    var hasSubMenu = menuItem.subMenus && menuItem.subMenus.length > 0 && !menuItem.disabled;
    if (hasSubMenu) {
        // Does it have any submenus?
        // hasSubMenu checks for subMenus and that it has a length.
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        var subMenuList = getMenuItems(menuItem.subMenus);
        // By default, use the menu item as a trigger
        var triggerOrSplitGroup = (React.createElement(MenuTrigger, null, createFluentMenuItem(menuItem, styles)));
        // If it is a split button, create a slightly different trigger group
        if ((_c = menuItem.contentActionOptions) === null || _c === void 0 ? void 0 : _c.split) {
            triggerOrSplitGroup = (React.createElement(MenuSplitGroup, null,
                createFluentMenuItem(menuItem, styles),
                React.createElement(MenuTrigger, null,
                    React.createElement(MenuItem, { "aria-label": menuItem.ariaLabel, role: "menuitem", onClick: stopDefaultPropagation }))));
        }
        var subMenu = (React.createElement(Menu, null,
            triggerOrSplitGroup,
            React.createElement(MenuPopover, null,
                React.createElement(MenuList, null, subMenuList))));
        return subMenu;
    }
    else {
        return createFluentMenuItem(menuItem, styles);
    }
};
//# sourceMappingURL=ActionMenuItem.js.map